// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Auth/Login';
import Sign from './components/Sign/Sign';
import CreateEmployee from './components/Employee/CreateEmployee';
import UpdateEmployee from './components/Employee/UpdateEmployee';
import PrivateRoute from './components/Common/PrivateRoute';
import MainLayout from './components/Layout/MainLayout';
import DataExport from './components/DataExport/DataExport';
import AdminDataExport from './components/AdminDataExport/AdminDataExport';
import FillDays from './components/FillDays/FillDays';
import AddLeave from './components/AddLeave/AddLeave';
import AdminAddLeave from './components/AdminAddLeave/AdminAddLeave';
import ListLeave from './components/ListLeave/ListLeave';
import AdminListLeave from './components/AdminListLeave/AdminListLeave';
import AdminAddHoliday from './components/AdminAddHoliday/AdminAddHoliday';
import AdminListHoliday from './components/AdminListHoliday/AdminListHoliday';
import Unauthorized from './components/Common/Unauthorized';
import './styles/styles.css'; // Import the CSS file

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
		<Route path="/unauthorized" element={<Unauthorized />} />
        <Route element={<PrivateRoute />}>
          <Route element={<MainLayout/>}>
            {/* Routes with permission checks */}
            <Route element={<PrivateRoute requiredPermission="Sign" />}>
              <Route path="/sign" element={<Sign />} />
            </Route>

            <Route element={<PrivateRoute requiredPermission="CreateEmployee" />}>
              <Route path="/createemployee" element={<CreateEmployee />} />
            </Route>

            <Route element={<PrivateRoute requiredPermission="UpdateEmployee" />}>
              <Route path="/updateemployee" element={<UpdateEmployee />} />
            </Route>

            <Route element={<PrivateRoute requiredPermission="AdminDataExport" />}>
              <Route path="/admindataexport" element={<AdminDataExport />} />
            </Route>

            <Route element={<PrivateRoute requiredPermission="DataExport" />}>
              <Route path="/dataexport" element={<DataExport />} />
			</Route>
			
			<Route element={<PrivateRoute requiredPermission="FillDays" />}>
              <Route path="/filldays" element={<FillDays />} />
			</Route>
			
			<Route element={<PrivateRoute requiredPermission="AddLeave" />}>
              <Route path="/addleave" element={<AddLeave />} />
			</Route>
			
			<Route element={<PrivateRoute requiredPermission="AdminAddLeave" />}>
              <Route path="/adminaddleave" element={<AdminAddLeave />} />
			</Route>
			
			<Route element={<PrivateRoute requiredPermission="AdminListLeave" />}>
              <Route path="/adminlistleave" element={<AdminListLeave />} />
			</Route>
			
			<Route element={<PrivateRoute requiredPermission="ListLeave" />}>
              <Route path="/listleave" element={<ListLeave />} />
			</Route>
			
			<Route element={<PrivateRoute requiredPermission="AdminAddHoliday" />}>
              <Route path="/adminaddholiday" element={<AdminAddHoliday />} />
			</Route>
			
			<Route element={<PrivateRoute requiredPermission="AdminListHoliday" />}>
              <Route path="/adminlistholiday" element={<AdminListHoliday />} />
			</Route>
			
            <Route path="/" element={<Navigate to="/sign" replace />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;